import React from 'react';

const Header = ({ currentUser, onTestAPI, onToggleSidebar, editingResult, editingComponent, editingProperty }) => {
  const hasLoadedData = editingResult || editingComponent || editingProperty ||
    localStorage.getItem('blendOptimizerLoadedEditData') ||
    localStorage.getItem('blendOptimizerLoadedComponents') ||
    localStorage.getItem('blendOptimizerLoadedProperties');

  const handleNewModel = () => {
    const keysToRemove = [
      'blendOptimizerLoadedEditData',
      'blendOptimizerLoadedComponents',
      'blendOptimizerLoadedProperties',
      'blendOptimizerEditData',
      'componentsToLoad',
      'propertiesToLoad',
      'customNotesToLoad',
      'componentsToEdit',
      'propertiesToEdit'
    ];

    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
    });

    window.location.reload();
  };
  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4">
        {/* Left Section */}
        <div className="flex items-center flex-1">
          <button
            onClick={onToggleSidebar}
            className="lg:hidden text-gray-500 hover:text-gray-700 mr-3 sm:mr-4"
          >
            <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <div className="flex items-center gap-2 sm:gap-3">
            <h1 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent whitespace-nowrap">
              Petroleum Blend Optimizer
            </h1>

            {editingResult && (
  <span className="ml-2 inline-flex items-center px-3 sm:px-4 py-2 sm:py-3 rounded-lg text-xs sm:text-sm md:text-base bg-yellow-100 text-yellow-800 border-2 border-yellow-300 shadow-sm sm:shadow-md">
    <svg className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 mr-1 sm:mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
    </svg>
    Saved: {editingResult.customName || editingResult.customTextField}
  </span>
)}

{hasLoadedData && (
  <button
    onClick={handleNewModel}
    className="ml-2 inline-flex items-center px-3 sm:px-4 py-2 sm:py-3 text-xs sm:text-sm md:text-base font-medium text-white bg-blue-600 hover:bg-blue-700 transition-colors rounded-lg shadow-sm sm:shadow-md"
    title="Start a new model (clears all current data)"
  >
    <svg className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 mr-1 sm:mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
    </svg>
    <span>New Model</span>
  </button>
)}



            {editingComponent && (
              <span className="ml-2 inline-flex items-center px-2 sm:px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800 border border-blue-300">
                <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
                Editing: {editingComponent.customName}
              </span>
            )}
            {editingProperty && (
              <span className="ml-2 inline-flex items-center px-2 sm:px-3 py-1 rounded-full text-xs font-large bg-purple-100 text-purple-800 border border-purple-300">
                <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
                Editing: {editingProperty.customName}
              </span>
            )}
          </div>
        </div>

        {/* Right Section */}
        <div className="flex items-center gap-2 sm:gap-4">

          <button
            className="hidden xs:flex px-3 py-2 text-xs sm:text-sm font-medium text-gray-600 hover:text-gray-700 transition-colors items-center gap-1 sm:gap-2 bg-gray-100 hover:bg-gray-200 rounded-lg"
            onClick={onTestAPI}
          >
            <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
            <span className="hidden sm:inline">Test API</span>
            <span className="sm:hidden">API</span>
          </button>

          <button
            className="xs:hidden p-2 text-gray-600 hover:text-gray-700 transition-colors bg-gray-100 hover:bg-gray-200 rounded-lg"
            onClick={onTestAPI}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
          </button>

          <div className="flex items-center gap-2 sm:gap-3 bg-white border border-gray-200 rounded-lg sm:rounded-xl px-2 sm:px-4 py-1 sm:py-2">
            <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center text-white font-bold text-xs sm:text-sm">
              {currentUser.username.charAt(0).toUpperCase()}
            </div>
            <div className="hidden xs:block text-right">
              <div className="text-xs sm:text-sm font-medium text-gray-900 truncate max-w-[80px] sm:max-w-none">
                {currentUser.username}
              </div>
              <div className="text-xs text-gray-500 capitalize">
                {currentUser.role}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;